import { createSlice } from "@reduxjs/toolkit";
import { DishWashGelProduct } from "../../Api/Api"; // Import API function

const dishWashGelSlice = createSlice({
    name: "dishWashGel",
    initialState: {
        products: [],  // Ensure initial state is an array
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(DishWashGelProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(DishWashGelProduct.fulfilled, (state, action) => {
                //console.log("Data Received in Redux:", action.payload);
                state.products = action.payload; // Ensure this is an array
                state.loading = false;
            })
            .addCase(DishWashGelProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default dishWashGelSlice.reducer;
